import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

import { dispatch } from 'appStore/store';
import { t } from 'i18next';
import { translations } from 'locales/translations';

import { addNotification, addNotifications } from 'app/containers/App/slice';

import notificationBuilder from 'utils/notificationBuilder';

import { type MaybeError, getErrorMessage } from './getErrorMessage';

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => next => action => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    console.error(action.payload);
    const title = t(translations.commonMessages.serverMessage);
    const message = getErrorMessage(action.payload as MaybeError);
    if (Array.isArray(message)) {
      dispatch(addNotifications(message.map(error => notificationBuilder('danger', error, title))));
    } else {
      dispatch(addNotification(notificationBuilder('danger', message, title)));
    }
  }

  return next(action);
};
